module.exports = __webpack_public_path__ + "img/k-ids_logo.2952e753.png";